import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DswToastService } from '@vi-succ/design-system-web';
import { NGXLogger } from 'ngx-logger';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const errorLoggingInterceptor: HttpInterceptorFn = (req, next) => {
  const logger = inject(NGXLogger);
  const toastService = inject(DswToastService);
  const translate = inject(TranslateService);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMsg = '';
      if (error.error instanceof ErrorEvent) {
        errorMsg = `Error: ${error.error.message}`;
      } else {
        errorMsg = `Error Code: ${error.status},  Message: ${error.message}`;
      }
      logger.error(errorMsg);
      if (error.url?.includes('et-api') && error.status >= 500) {
        const errorKey = 'common.error_occured';
        toastService.open(translate.instant(errorKey), 'error');
      }

      return throwError(() => new Error(errorMsg));
    })
  );
};
